import * as _ from 'lodash';
import { useEffect, useState } from 'react';
import { IDonorStatus, IDashRegistrationLog, IDonorRegistration, IListItem } from '@nkr/models/index';
import { Button, Glyphicon, Label, Well } from 'react-bootstrap';
import LogEntry from './log-entry';
import DeleteLogEntryConfirmation from './delete-log-entry-confirmation';
import ReactHtmlParser from 'react-html-parser';
import { cardBodyStyle, cardFooterStyle, cardHeaderStyle, cardStyle, cardTitleRowStyle, cardTitleTextStyle } from '../styles';

interface IProps {
    data: IDonorRegistration,
    statusList: IDonorStatus[],
    actionList: IListItem[],
    isMobile: boolean,
    disabled: boolean,
    onSaveLogEntry: (dashRegistrationId: number, actionTaken: number, comments: string) => void,
    onUpdateLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => void,
    onDeleteLogEntry: (id: number, dashRegistrationId: number) => void
}

const DonorLog = (props: IProps) => {
    const [addEdit, setAddEdit] = useState<{ show: boolean, data: IDashRegistrationLog }>({ show: false, data: null });
    const [deleteLog, setDeleteLog] = useState<{ show: boolean, data: IDashRegistrationLog }>({ show: false, data: null });

    useEffect(() => {
        setAddEdit({ show: false, data: null });
        setDeleteLog({ show: false, data: null });
    }, []);

    const handleShowAddEdit = (data: IDashRegistrationLog) => {
        setAddEdit({ show: true, data });
    };

    const handleCancelAdd = () => {
        setAddEdit({ show: false, data: null });
    };

    const handleSaveLogEntry = (actionTaken: number, comments: string) => {
        let dashRegistrationId = props.data.id;
        let id = addEdit.data != null ? addEdit.data.id : 0;

        if (id > 0) {
            props.onUpdateLogEntry(id, dashRegistrationId, actionTaken, comments);
        } else {
            props.onSaveLogEntry(dashRegistrationId, actionTaken, comments);
        }

        setAddEdit({ show: false, data: null });
    };

    const handleConfirmDeleteLogEntry = (data: IDashRegistrationLog) => {
        setDeleteLog({ show: true, data });
    };

    const handleCancelDeleteLogEntry = () => {
        setDeleteLog({ show: false, data: null });
    };

    const handleDeleteLogEntry = () => {
        let { id: dashRegistrationId } = props.data;
        let id = deleteLog.data.id;

        props.onDeleteLogEntry(id, dashRegistrationId);

        setDeleteLog({ show: false, data: null });
    };

    const logList = _.orderBy(props.data.logs, item => {
        if (item.updateDateTime != '') {
            return new Date(item.updateDateTime);
        } else {
            return new Date(item.logDateTime);
        }
    }, ['desc']);

    return (
        <>
            <div style={cardStyle}>
                <div style={cardHeaderStyle}>
                    <div style={cardTitleRowStyle}>
                        <span style={cardTitleTextStyle}>LOGS</span>
                    </div>
                </div>
                <div style={{ ...cardBodyStyle, padding: 0 }}>
                    {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, marginBottom: 5 }}>
                        <h3 style={{ margin: 0 }}>Logs</h3>
                        {props.disabled == false && (
                            <Button bsStyle='link' onClick={() => handleShowAddEdit(null)}>Add Log Entry</Button>
                        )}
                    </div> */}

                    {addEdit.show && (
                        <div style={{ padding: '10px 10px 0px 10px' }}>
                            <LogEntry
                                data={addEdit.data}
                                actionList={props.actionList}
                                onSave={handleSaveLogEntry}
                                onCancel={handleCancelAdd}
                            />
                        </div>
                    )}

                    <div style={{ overflowY: 'scroll', maxHeight: 300 }}>
                        {logList.map(log => {
                            if (deleteLog.data != null && deleteLog.data.id == log.id) {
                                return (
                                    <DeleteLogEntryConfirmation
                                        show={deleteLog.show}
                                        data={deleteLog.data}
                                        onDelete={handleDeleteLogEntry}
                                        onCancel={handleCancelDeleteLogEntry}
                                    />
                                )
                            } else {
                                return (
                                    <Well bsSize='sm' key={'log-' + log.id} style={{ padding: 7, marginBottom: 5 }}>
                                        <div style={{ marginBottom: 15, display: 'flex', justifyContent: 'space-between' }}>
                                            <div>
                                                {log.updateDateTimeForDisplay != '' && (
                                                    <div><Label bsStyle='info' style={{ color: 'black' }}>Updated {log.updateDateTimeForDisplay} By {log.updatedByFullName}</Label></div>
                                                )}
                                                <div><Label bsStyle='primary'>Created {log.logDateTimeForDisplay} By {log.createdByFullName}</Label></div>
                                            </div>

                                            {log.isEditable == false && log.isDeletable == false &&
                                                <Glyphicon glyph='lock' style={{ color: 'darkred' }} title="This is a system generated log entry and can't be edited nor deleted" />
                                            }
                                        </div>

                                        <div style={{ backgroundColor: 'white', border: '1px solid #ddd', borderRadius: 4, padding: 5, marginBottom: 5 }}>{ReactHtmlParser(log.comments.replace(/(?:\r\n|\r|\n)/g, '<br/>'))}</div>

                                        <div className='text-right'>
                                            {log.isEditable &&
                                                <Button style={{ marginRight: 5 }} title='Edit this log entry...' onClick={() => handleShowAddEdit(log)}>
                                                    <Glyphicon glyph='edit' />
                                                </Button>
                                            }

                                            {log.isDeletable &&
                                                <Button title='Delete this log entry...' onClick={() => handleConfirmDeleteLogEntry(log)}>
                                                    <Glyphicon glyph='trash' />
                                                </Button>
                                            }
                                        </div>
                                    </Well>
                                );
                            }
                        })}

                        {(props.data.logs == null || props.data.logs.length == 0) &&
                            <Well bsSize='sm'>
                                No log entries have been added yet....
                            </Well>
                        }
                    </div>
                </div>
                <div style={cardFooterStyle}>
                    {props.disabled == false && (
                        <Button bsStyle='primary' bsSize='sm' onClick={() => handleShowAddEdit(null)}>Add Log Entry</Button>
                    )}
                </div>
            </div>
        </>
    );
}

export default DonorLog;